<template>
  <div class="c-app flex-row align-items-center amsys-header">
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CHeaderBrand class="d-lg-none" to="/Approval">
          <img
            src="img/arrow.png"
            width="60"
            style="padding-left:15px; padding-right:10px;"
          />
          <h3 style="padding-left: 10px;">
            <b>
              <font color="Green">PURCHASE</font>
              <font color="gray">ORDER</font></b
            >
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <img
            src="img/arrow.png"
            width="60"
            @click="backClick()"
            style="padding-left:10px; padding-right:10px;"
          />
          <h2>
            <b>
              <font color="Green">PURCHASE</font>
              <font color="gray">ORDER</font></b
            >
          </h2>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main amsys-approval-main">
          <CContainer fluid class="amsys-approval-container">
            <transition name="fade" mode="out-in">
              <div>
                <CRow>
                  <CCol
                    sm="6"
                    class="amsys-approval-col"
                    v-for="item in result"
                    v-bind:data="item"
                    v-bind:key="item.Oid"
                  >
                    <transition name="fade">
                      <CCard v-if="show" style="width: 100%;">
                        <CCollapse :show="isCollapsed" :duration="400">
                          <CCardBody style="padding: 0rem;">
                            <table>
                              <tr>
                                <td
                                  class="amsys-approval-td-left"
                                  @click="
                                    handleClick(
                                      item.Oid,
                                      item.Number,
                                      item.Date,
                                      item.Sequence
                                    )
                                  "
                                >
                                  <b>
                                    {{ item.Number }}
                                  </b>
                                </td>
                                <td class="amsys-approval-td-right">
                                  <CDropdown
                                    class="c-header-nav-items"
                                    placement="bottom-end"
                                    add-menu-classes="pt-0"
                                  >
                                    <template #toggler>
                                      <CHeaderNavLink>
                                        <img
                                          src="img/clipart861651.png"
                                          height="20"
                                          width="20"
                                          alt="Logo"
                                        />
                                      </CHeaderNavLink>
                                    </template>
                                    <CDropdownItem
                                      @click="
                                        approve(
                                          1,
                                          item.Oid,
                                          item.BudgetAccount,
                                          item.Number,
                                          item.Date,
                                          item.Sequence
                                        )
                                      "
                                    >
                                      Approve
                                    </CDropdownItem>
                                    <CDropdownItem
                                      @click="
                                        approve(
                                          2,
                                          item.Oid,
                                          item.BudgetAccount,
                                          item.Number,
                                          item.Date,
                                          item.Sequence
                                        )
                                      "
                                    >
                                      Reject
                                    </CDropdownItem>
                                  </CDropdown>
                                </td>
                              </tr>
                            </table>

                            <hr style="margin-top: 0rem;margin-bottom: 0rem;" />
                            <table
                              @click="
                                handleClick(
                                  item.Oid,
                                  item.Number,
                                  item.Date,
                                  item.Sequence
                                )
                              "
                              class="amsys-approval-table-14"
                            >
                              <tr>
                                <td class="td-left">
                                  <CIcon name="cil-user" />
                                </td>
                                <td>
                                  {{ item.Requestor }}
                                </td>
                                <td class="td-left">
                                  <CIcon name="cil-calendar" />
                                </td>
                                <td>
                                  {{ item.Date }}
                                </td>
                              </tr>
                              <tr>
                                <td class="td-left">
                                  <CIcon name="cil-settings" />
                                </td>
                                <td>
                                  {{ item.Department }}
                                </td>
                                <td class="td-left">
                                  <CIcon name="cil-dollar" />
                                </td>
                                <td>
                                  {{ item.Currency }}
                                  {{
                                    parseFloat(item.GrandTotal)
                                      .toFixed(2)
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td class="td-left">
                                  <CIcon name="cil-file" />
                                </td>
                                <td colspan="3">
                                  {{ item.Description }}
                                </td>
                              </tr>
                            </table>

                            <br />
                          </CCardBody>
                        </CCollapse>
                      </CCard>
                    </transition>
                  </CCol>
                </CRow>
                <CRow align="center" justify="center" v-if="showNotFound">
                  <CCol style="margin-top: 4em;">
                    <img
                      src="img/ic_notfound.png"
                      style="padding-left:10px; padding-right:10px;"
                    />
                  </CCol>
                </CRow>
              </div>
            </transition>
          </CContainer>
        </main>
      </div>
      <CRow class="justify-content-center">
        <CAlert color="primary" v-if="notif" id="notifError"> </CAlert>
      </CRow>
      <CRow class="justify-content-center">
        <div
          id="loading-contentx"
          v-if="loading"
          style="margin-bottom: 20%;"
        ></div>
      </CRow>
    </CWrapper>
    <CModal
      size="sm"
      :show.sync="modalOverBudget"
      color="info"
      style="font-size: 15px;"
    >
      <font style="font-size:15px; width: 80%;"
        ><b>BUDGET EXCESS REASON</b></font
      >
      <br />
      <br />
      <textarea
        style="font-size:15px;"
        class="form-control"
        v-model="BudgetExcessReason"
        name="textarea-input"
        rows="5"
        placeholder="Budget Excess Reason.."
      >
      </textarea>
      <template #footer>
        <CButton
          @click="modalOverBudget = false"
          color="secondary"
          style="font-size: 15px;"
          >Close</CButton
        >
        <CButton
          @click="actionModalOverBudget()"
          style="font-size: 15px;"
          class="btn btn-info"
        >
          OK
        </CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      :show.sync="modalOverBudget2"
      color="info"
      style="font-size: 14px;"
    >
      <font style="font-size: 14px; width: 80%;"><b>OVER BUDGET</b></font>
      <br />
      <br />
      <table style="font-size: 14px;">
        <tr>
          <td style="padding: 0.3rem; text-align:center;">
            <b>Budget Account</b>
          </td>
        </tr>
        <tr v-for="item in hasilOver">
          <td>{{ item.result }}</td>
        </tr>
      </table>

      <template #footer>
        <CButton
          @click="modalOverBudget2 = false"
          color="secondary"
          style="font-size: 14px;"
          >Close</CButton
        >
      </template>
    </CModal>
    <CModal
      size="sm"
      :show.sync="modalNote"
      color="info"
      style="font-size: 15px;"
    >
      <font style="font-size:15px; width: 80%;"><b>NOTES</b></font>
      <br />
      <br />
      <textarea
        style="font-size:15px;"
        class="form-control"
        v-model="Notes"
        name="textarea-input"
        rows="5"
        placeholder="Notes.."
      >
      </textarea>
      <template #footer>
        <CButton
          @click="modalNote = false"
          color="secondary"
          style="font-size: 15px;"
          >Close</CButton
        >
        <CButton
          @click="actionModalNote()"
          style="font-size: 15px;"
          class="btn btn-info"
        >
          OK
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import PullTo from "vue-pull-to";
import CryptoJS from "crypto-js";
Vue.use(VueCordova);
Vue.use(PullTo);

export default {
  name: "PurchaseOrder",
  components: {
    PullTo,
  },
  data() {
    return {
      result: [],
      hasilOver: [],

      modalNote: false,
      modalOverBudget: false,
      modalOverBudget2: false,
      show_input: false,
      show: false,
      showNotFound: false,
      notif: false,
      notifError: "",
      id: "",
      number: "",
      loading: false,
      isCollapsed: true,
      OverBudget: 0,
      oid: "",
      BudgetExcessReason: "",
      Notes: "",
      BudgetAccount: "",
      loadRefresh: false,
      loadDone: false,
      Dates: "",

      isNew: false,

      urlServer: "",
      urlIBUGS: "",
    };
  },
  methods: {
    refresh(loaded) {
      this.reloadData();
      this.currentdate = new Date();
      loaded("done");
    },
    stateChange(state) {
      if (state === "pull") {
        this.loadRefresh = false;
        this.loadDone = false;
      } else if (state === "trigger") {
        this.loadRefresh = true;
        this.loadDone = false;
      } else if (state === "loading") {
        this.loadRefresh = true;
        this.loadDone = false;
      } else if (state === "loaded-done") {
        this.loadDone = true;
        this.loadRefresh = false;
      }
    },
    handleClick(id, number, date, seq) {
      this.$router.push({
        path: "PurchaseOrderDetail",
        query: { id: id, number: number, date: date, seq: seq },
      });
    },
    backClick() {
      this.$router.push({ path: "approval" });
    },
    SendNotification(no, notif) {
      let formData = {
        app_id: "3f8b7bb1-c4e1-41d2-85dd-37ce37cbd4f1",
        included_segments: ["Subscribed Users"],
        headings: { en: no },
        contents: { en: notif },
      };
      var data = "NGY1M2VlOGQtNDY3Yi00ZTFiLThjZDQtNDAzOTQ0ZDE1YmYz";
      axios
        .post("https://onesignal.com/api/v1/notifications", formData, {
          headers: {
            "content-type": "application/json;",
            authorization: "Basic " + data,
          },
        })
        .then((res) => {
          this.resultLoading = res;
          console.log(this.resultLoading);
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          vue.$toast.open({
            message: error,
            type: "error",
            position: "bottom",
          });
        });
    },
    PostApprovalStatus(status) {
      this.loading = true;
      let data = localStorage.token;
      let user = localStorage.user;
      let no = this.number;

      if (
        status == 1 &&
        this.OverBudget == 1 &&
        this.BudgetExcessReason == ""
      ) {
        this.loading = false;
        Vue.$toast.open({
          message: "Budget Excess Reason not null !",
          type: "warning",
          position: "bottom",
        });
      } else if (status == 2 && this.Notes == "") {
        this.loading = false;
        Vue.$toast.open({
          message: "Notes not null !",
          type: "warning",
          position: "bottom",
        });
      } else {
        if (status == 2) {
          this.BudgetExcessReason = this.Notes;
        }

        let Oid = this.oid;
        let message = "";
        let messageNotif = "";
        if (status == 1) {
          message = "data has been approved";
          messageNotif = no + "- has been approved by " + user;
        } else {
          message = "data has been rejected";
          messageNotif = no + "- has been rejected by " + user;
        }
        const form = new FormData();
        form.append("OverBudget", this.OverBudget);
        form.append("BudgetExcessReason", this.BudgetExcessReason);
        form.append("Notes", this.Notes);
        form.append("Status", status);
        form.append("Oid", Oid);
        form.append("Category", "PO");
        form.append("BudgetAccountParam", this.BudgetAccount);
        let sendData = JSON.stringify(Object.fromEntries(form));

        let linkApprovePO = this.isNew
          ? "Api/Approval/PostApprovalStatus/"
          : "Api/Approval/PostApprovalStatus2/";
        axios
          .post(`${this.urlServer}/${linkApprovePO}`, sendData, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          })
          .then((res) => {
            this.SendNotification(no, messageNotif);
            this.modalOverBudget = false;
            this.modalNote = false;
            this.loading = false;
            Vue.$toast.open({
              message: message,
              type: "success",
              position: "bottom",
            });
            this.reloadData();
          })
          .catch((error) => {
            this.loading = false;
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          });
      }
    },
    OverBudgetValidationChecker() {
      let data = localStorage.token;
      const form = new FormData();
      form.append("TransIDParam", this.oid);
      form.append("TransTypeParam", "PO");
      let sendData = JSON.stringify(Object.fromEntries(form));
      axios
        .post(
          `${this.urlServer}/Api/Approval/OverBudgetValidationChecker/`,
          sendData,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          }
        )
        .then((res) => {
          console.log(res.data[0]);
          this.OverBudget = res.data[0].OverBudget;
        })
        .catch((error) => {
          console.error(error);
          vue.$toast.open({
            message: error,
            type: "error",
            position: "bottom",
          });
        });
    },
    CheckeNumberTransaction() {
      let data = localStorage.token;
      const param = { Oid: this.oid };
      axios
        .post(`${this.urlServer}/Api/Approval/GetPurchaseOrderByID/`, param, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          this.number = res.data[0].Number;
          console.log(this.number);
        })
        .catch((error) => {
          console.error(error);
          vue.$toast.open({
            message: error,
            type: "error",
            position: "bottom",
          });
        });
    },
    changeFormatDate(dt) {
      let date = new Date(dt);
      let dd = String(date.getDate()).padStart(2, "0");
      let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = date.getFullYear();
      const setToday = yyyy + "-" + mm + "-" + dd;
      return setToday;
    },
    checkForUnique(arrToCheck, keyName) {
      const uniqueValues = [...new Set(arrToCheck.map((v) => v[keyName]))];
      if (uniqueValues.length == 1) {
        // console.log("VALUE SAMA SEMUA");
        return true;
      }
      // console.log("VALUE ADA BEDA");
      return false;
    },
    sumByKey(arr, key, value) {
      const grouped = Map.groupBy(arr, (o) => o[key]);
      return Array.from(grouped.values(), (group) =>
        group.reduce(
          (acc, obj) => ({
            ...obj,
            [value]: (acc[value] ?? 0) + obj[value],
          }),
          {}
        )
      );
    },
    detailPOByID(status, oid, dd) {
      this.oid = oid;
      const param = { Oid: oid };
      let data = localStorage.token;
      axios
        .post(
          `${this.urlServer}/Api/Approval/GetPurchaseOrderDetailByID2/`,
          param,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          }
        )
        .then(async (res) => {
          this.loading = false;
          if (status == 1) {
            this.PostApprovalStatus(1);
          } else if (status === 2) {
            this.modalNote = true;
          }
          // const det = this.sumByKey(res.data, "BudgetAccountOid", "Total");
          // //Over budget checker
          // let data = localStorage.getItem("token-iBugs");

          // let sendData = det.map((x) => ({
          //   date: this.changeFormatDate(dd),
          //   budgetAccountOid: x.BudgetAccountOid,
          //   amount: x.Total,
          // }));
          // console.log("SEND", sendData);
          // await axios
          //   .post(
          //     `${this.urlIBUGS}/Api/Budget/OverBudgetValidationChecker/`,
          //     sendData,
          //     {
          //       headers: {
          //         "Access-Control-Allow-Origin": "*",
          //         "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
          //         "Access-Control-Allow-Headers":
          //           "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          //         "Content-Type": "application/json",
          //         Authorization: "Bearer " + data,
          //       },
          //     }
          //   )
          //   .then((res) => {
          //     const ab = res.data;
          //     console.log(res.data);
          //     let check = this.checkForUnique(ab, "result");
          //     console.log(check);
          //     if (check) {
          //       let findTrue = ab.findIndex((x) => x.result == "NULL");
          //       if (findTrue === 0) {
          //         this.OverBudget = 0;
          //       } else {
          //         this.OverBudget = 1;
          //         const ValToRemove = "NULL";
          //         const h = res.data.filter(
          //           (item) => item.result !== ValToRemove
          //         );
          //         this.hasilOver = h;
          //       }
          //     } else {
          //       const ValToRemove = "NULL";
          //       const h = res.data.filter(
          //         (item) => item.result !== ValToRemove
          //       );
          //       this.hasilOver = h;
          //       this.OverBudget = 1;
          //     }
          //     if (status == 1 && this.OverBudget == 1) {
          //       this.modalOverBudget2 = true;
          //     } else if (status === 2) {
          //       this.modalNote = true;
          //     } else {
          //       this.PostApprovalStatus(1);
          //     }
          //     this.loading = false;
          //   })
          //   .catch((error) => {
          //     this.loading = false;
          //   });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    approve(status, oid, ba, number, dd, seq) {
      let d = new Date(dd).getFullYear();
      this.isNew = d > 2023 ? true : false;
      console.log(seq);
      this.number = number;

      let tgl = new Date(dd).getFullYear();
      if (tgl > 2023) {
        if (seq != "1") {
          this.detailPOByID(status, oid, dd);
        } else {
          this.oid = oid;
          this.PostApprovalStatus(1);
        }
      } else {
        let data = localStorage.token;
        this.oid = oid;
        this.BudgetAccount = ba;
        const form = new FormData();
        form.append("TransIDParam", this.oid);
        form.append("TransTypeParam", "PO");
        let sendData = JSON.stringify(Object.fromEntries(form));
        axios
          .post(
            `${this.urlServer}/Api/Approval/OverBudgetValidationChecker/`,
            sendData,
            {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            }
          )
          .then((res) => {
            console.log(res.data[0]);
            this.OverBudget = res.data[0].OverBudget;
            if (status == 1 && this.OverBudget == 1) {
              this.modalOverBudget = true;
            } else if (status === 2) {
              this.modalNote = true;
            } else {
              this.PostApprovalStatus(1);
            }
          })
          .catch((error) => {
            console.error(error);
            vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          });
      }
      //this.CheckeNumberTransaction();
      // const param = { Oid: this.oid };
      // axios
      //   .post(`${this.urlServer}/Api/Approval/GetPurchaseOrderByID/`, param, {
      //     headers: {
      //       "Access-Control-Allow-Origin": "*",
      //       "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
      //       "Access-Control-Allow-Headers":
      //         "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
      //       "Content-Type": "application/json",
      //       Authorization: "Bearer " + data,
      //     },
      //   })
      //   .then((res) => {
      //     this.number = res.data[0].Number;
      //     console.log(this.number);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //     vue.$toast.open({
      //       message: error,
      //       type: "error",
      //       position: "bottom",
      //     });
      //   });
    },
    actionModalOverBudget() {
      this.PostApprovalStatus(1);
    },
    actionModalNote() {
      this.PostApprovalStatus(2);
    },
    reloadData() {
      this.loading = true;
      let data = localStorage.token;
      if (typeof data != "undefined") {
        axios
          .get(`${this.urlServer}/Api/Approval/GetPurchaseOrderToApprove/`, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          })
          .then((res) => {
            if (res.data.length > 0) {
              this.show = true;
              this.showNotFound = false;
              console.log(res.data);
              this.result = res.data;
              this.loading = false;
            } else {
              this.show = false;
              this.showNotFound = true;
              this.loading = false;
            }
          })
          .catch((error) => {
            console.error(error);
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.$router.push({ path: "/pages/login" });
      }
      this.loading = false;
    },
  },
  beforeMount() {
    this.loading = true;
    console.log("PO");
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    let urlIb = CryptoJS.AES.decrypt(localStorage.urlIBUGS, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    const urlIB = urlIb.toString(CryptoJS.enc.Utf8);
    this.urlServer = urlS;
    this.urlIBUGS = urlIB;

    let data = localStorage.token;
    if (typeof data != "undefined") {
      axios
        .get(`${urlS}/Api/Approval/GetPurchaseOrderToApprove/`, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          if (res.data.length > 0) {
            this.show = true;
            this.showNotFound = false;
            this.result = res.data;
          } else {
            this.show = false;
            this.showNotFound = true;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    } else {
      this.loading = false;
      this.$router.push({ path: "/pages/login" });
    }
    this.loading = false;
  },
};
</script>
